import { IconVariants } from "@next-platform/client-common-spicy-ui";
import { CHARACTER_MODERATION_STATUS, useKindeFeatureFlags } from "@next-platform/client-common-core";

import { FilterKeys } from "@/components/type";

import Dropdown from "../../common/Dropdown";

interface MyChatbotsFilterDropdownProps {
  filterBy?: FilterKeys;
  filterValue: string;
  onChange: (filterKey: FilterKeys, filterValue: string) => void;
}

export default function MyChatbotsFilterDropdown({ filterValue, onChange }: MyChatbotsFilterDropdownProps) {
  const { hasAccessToV2 } = useKindeFeatureFlags();

  const filterItems = [
    {
      label: "All",
      value: "All",
      filterKey: FilterKeys.ALL,
    },
    {
      label: "Public",
      value: "public",
      filterKey: FilterKeys.VISIBILITY,
    },
    {
      label: "Private",
      value: "private",
      filterKey: FilterKeys.VISIBILITY,
    },
    {
      label: "Unlisted",
      value: "hidden",
      filterKey: FilterKeys.VISIBILITY,
    },
    {
      label: "Under Review",
      value: CHARACTER_MODERATION_STATUS.PENDING,
      filterKey: FilterKeys.MODERATION_STATUS,
    },
    {
      label: "Action Required",
      value: CHARACTER_MODERATION_STATUS.FIX_REQUIRED,
      filterKey: FilterKeys.MODERATION_STATUS,
    },
  ];

  const getCurrentLabel = () => {
    const item = filterItems.find((item) => item.value === filterValue);
    return item ? item.label : "All";
  };

  return (
    <Dropdown
      currentValue={getCurrentLabel()}
      hasAccessToV2={hasAccessToV2 || true}
      listItems={filterItems.map((item) => ({
        label: item.label,
        value: item.value,
        onPress: () => onChange(item.filterKey, item.value),
      }))}
      iconEnd={IconVariants.CHEVRON_DOWN}
    />
  );
}
